<form [formGroup]="form" (ngSubmit)="onSubmit()">
	<app-form-title [editMode]="location !== undefined" model="Location"></app-form-title>

	<app-name-field [fg]="form" formGroupOrControlName="name"></app-name-field>

	<app-text-field [fg]="form" formGroupOrControlName="ssoLocationId" label="SSO Location ID"></app-text-field>

	<div class="buttons">
		<button nz-button nzType="primary" type="submit" [disabled]="form.invalid || loading">Submit</button>
		<button nz-button type="button" (click)="clear(); $event.preventDefault()">Clear</button>
	</div>
</form>
